$(() => {
    $(document).on('change', '.diversityinfo', function (event) {
        event.preventDefault();
        var parentContext = this;
        var selectedValue = $(parentContext).prop('type') === 'checkbox' ? $(parentContext).prop('checked') : $(parentContext).val();
        var isRequiredValue = String(selectedValue).toLowerCase() === String($(parentContext).data("targetValue")).toLowerCase();
        var $target = $($(parentContext).data("targetHide"));
        var $childSelectControl = $target.find('select');
        var $childInputControl = $target.find('input[type="text"]');

        if ($childSelectControl.length > 0) {
            $($childSelectControl).selectpicker('val', null);
            $($childSelectControl).change();
        }
        if ($childInputControl.length > 0) {
            $($childInputControl).val('');
        }

        if (isRequiredValue) {
            $target.removeClass('hide');
        }
        else {
            $target.addClass('hide');
        }
    });
});